import React from 'react';
import { Avatar } from 'components/atoms/Avatar';
import useStyle from './pedagogicalChallengesWinnersBlock.style';
import { AwardsList } from 'graphql/generated/graphql';
import { mediaDir } from 'appolloConfig';

interface PedagogicalChallengesWinnersBlockProps {
  awardsList: AwardsList[];
}

export const PedagogicalChallengesWinnersBlock = ({
  awardsList
}: PedagogicalChallengesWinnersBlockProps) => {
  const classes = useStyle();

  return (
    <>
      <div className={classes.root}>
        {awardsList.length > 0 ? (
          awardsList.map((award, index) => (
            <div className={classes.categoryContainer} key={index}>
              <p>{award.category}</p>
              {award.recompenses_winners.length > 0 &&
                award.recompenses_winners.map(winner => (
                  <div className={classes.winnerContainer} key={winner.id}>
                    <div>
                      <Avatar
                        source={
                          winner.avatar?.media?.url
                            ? mediaDir + winner.avatar.media.url
                            : null
                        }
                        variant="small"
                        alt="Avatar d'un gagnant"
                      />
                    </div>
                    <div className={classes.name}>
                      <p>{winner.username}</p>
                      <p className={classes.lyceeName}>
                        {winner.classes.length > 0 &&
                          winner.classes[0]?.lycee?.name}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          ))
        ) : (
          <p>Les résultats ne sont pas encore annoncés !</p>
        )}
      </div>
    </>
  );
};
